export default __webpack_public_path__ + "static/media/DownloadModalImg.c313e993.png";